import { render } from "./ZfMsg.vue?vue&type=template&id=13ce0b37&scoped=true"
import script from "./ZfMsg.vue?vue&type=script&lang=js"
export * from "./ZfMsg.vue?vue&type=script&lang=js"

import "./ZfMsg.vue?vue&type=style&index=0&id=13ce0b37&scoped=true&lang=css"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ce0b37"]])

export default __exports__